<script setup lang="ts">
import OzBox, { OzBoxColors } from '@@/library/v4/components/OzBox.vue'
import type { OzMenuRowsRow } from '@@/library/v4/components/OzMenuRows.vue'
import OzMenuRows, {
  OzMenuRowsFocusStyle,
  OzMenuRowsRowRole,
  OzMenuRowsSizePreset,
} from '@@/library/v4/components/OzMenuRows.vue'

withDefaults(
  defineProps<{
    label: string
    rows: OzMenuRowsRow[]
    darkMode: boolean
    containerStyle?: Record<string, string>
    sizePreset?: OzMenuRowsSizePreset
    testId?: string
  }>(),
  {
    testId: undefined,
    containerStyle: undefined,
    sizePreset: OzMenuRowsSizePreset.H56px,
  },
)

const emit = defineEmits(['select-row'])
const onRowSelect = (event, payload) => {
  emit('select-row', event, payload)
}
</script>
<template>
  <div class="rounded-2.5xl overflow-hidden">
    <OzBox
      :style="containerStyle"
      :color="OzBoxColors.Primary"
      :dark-mode="darkMode"
      :class="[
        'flex flex-col',
        'h-full w-full',
        'overflow-auto',
        'py-1',
        darkMode ? 'scrollbar-thin-dark' : 'scrollbar-thin',
      ]"
    >
      <OzMenuRows
        :accessibility-role="'menu'"
        :aria-label="label"
        :dark-mode="darkMode"
        :size-preset="sizePreset"
        :common-settings="{
          role: OzMenuRowsRowRole.MenuItemRadio,
          iconSize: 20,
        }"
        :focus-style="OzMenuRowsFocusStyle.Grey100"
        :x-last-row-divider="false"
        :rows="rows"
        :data-testid="testId"
        @select-row="onRowSelect"
      />
      <slot></slot>
    </OzBox>
  </div>
</template>
